interface PasswordPolicy {
    minLength: number;
    maxLength: number;
}

const defaultPasswordPolicy: PasswordPolicy = {
    minLength: 8,
    maxLength: 32,
};

export function validatePassword( password: string, policy: PasswordPolicy = defaultPasswordPolicy ) {
    if ( password.length < policy.minLength ) {
        return false;
    }

    if ( password.length > policy.maxLength ) {
        return false;
    }

    return true;
}
